import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-device-operation',
  templateUrl: './device-operation.component.html',
  styleUrls: ['./device-operation.component.scss']
})
export class DeviceOperationComponent implements OnInit {
  comments: string = "";

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DeviceOperationComponent>,) {

  }

  ngOnInit(): void {
  }

  updateDevice() {
    this.dialogRef.close({ notes:this.comments});
  }

}


